import PropTypes from 'prop-types';

import { colors } from 'styles/theme';

import Text from '../Text/Text';

function PromoCardsTitle({ text, ...restProps }) {
  return (
    <Text
      variant="caption"
      fontWeight={300}
      color={colors.inputBorder}
      uppercase
      {...restProps}
    >
      {text}
    </Text>
  );
}

PromoCardsTitle.propTypes = {
  text: PropTypes.string,
};

export default PromoCardsTitle;
